import baseURL from '../api/url'

export const getOrdersListURL = (pageNo, size, search) => {
    const paramsObj = {
        page_number: pageNo,
        page_limit: size,
    }
    const order_type = search.order_type
    const orderStatus = search.orderStatus
    const start_date = search.start_date
    const end_date = search.end_date
    const storeId = search.store_id
    const orderId = search.order_id
    const loyaltyId = search.loyalty_id
    const customerName = search.customer_name
    const transactionStatus = search.transaction_status
    if (order_type) paramsObj.order_type = order_type
    if (orderStatus) paramsObj.order_status = orderStatus[0]
    if (start_date) paramsObj.created_from = start_date
    if (end_date) paramsObj.created_until = end_date
    if (storeId) paramsObj.storeId = storeId[0]
    if (orderId) paramsObj.orderId = orderId[0]
    if (loyaltyId) paramsObj.loyaltyId = loyaltyId[0]
    if (customerName) paramsObj.customerName = customerName[0]
    if (transactionStatus) paramsObj.transactionStatus = transactionStatus[0]
    let paramsUrl = new URLSearchParams(paramsObj).toString()
    if (paramsUrl.length) paramsUrl = `?${paramsUrl}`
    return `${baseURL.CONFIG_URL}/order/order/search${paramsUrl}`
}
